import styled from "styled-components";

import { Box } from "atoms";

export const Grid = styled(Box)`
  display: grid;
`;
